import OffboardL1DetailPage from "../offboard-l1/offboard-l1-detail-page.tsx";
import type { PageProps } from "../../types/page.ts";

export default function OffboardITDetailPage(props: PageProps) {
    return <OffboardL1DetailPage {...props} reviewRole="IT" />;
}
